module.exports = ".success {\n  color: green;\n  padding: 33px 0 0 0; }\n\n.alert {\n  color: red;\n  padding: 33px 0 0 0; }\n\n.vertical-offset-100 {\n  padding-top: 150px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forgotpassword/forgotpassword.component.scss
// module id = ./src/app/forgotpassword/forgotpassword.component.scss
// module chunks = main